<template>
  <div class="sectionx">
    <br />
    <form>
      <div class="row">

        <div class="col s12 m7">
          <!-- <div class="card-panel"> -->
          <FilterDiv inputId="filterDuration" :data="filterDurationData" :startAgain="resetDuration"
            @selected="handlePick" @searching="handleSearch" @clear="handleClear" />
          <!-- </div> -->
        </div>

        <div class="col s12 m5">
          <!-- <div class="card-panel"> -->
          <FilterDiv inputId="filterCategory" :data="filterCategoryData" :startAgain="resetCategory"
            @selected="handlePick" @searching="handleSearch" @clear="handleClear" />
          <!-- </div> -->
        </div>
      </div>

    </form>
  </div>
</template>

<script>
import { computed, onMounted, ref, watchEffect } from "vue";
import FilterDiv from "@/components/search/FilterDiv.vue";
import { searchMonths } from "@/composables/fxLibrary/months";

export default {
  name: "FilterClaimComponent",
  components: { FilterDiv },
  emits: ["search"],
  setup(props, context) {
    const responseCategoryDefault = ref(null);
    const responseDurationDefault = ref(null);
    const resetCategory = ref(null);
    const resetDuration = ref(null);
    const searchBody = ref([]);
    const selectedItem = ref({ id: "filterPass", value: false, special: false });
    const selectedCategory = ref("");
    const selectedDuration = ref("");


    // enrollee
    const filterCategoryData = computed(() => {
      // start
      let val = {
        "All Status": null,
      };

      let valPlus;

      if (responseCategoryDefault.value) {
        if (responseCategoryDefault.value.key == "filterCategory") {
          valPlus = responseCategoryDefault.value.value.reduce((newArr, x) => {
            newArr[x.cat] = null;
            return newArr;
          }, {});
          val = { ...val, ...valPlus };
        }
      }

      // return final
      return val;
    });

    // Duration
    const filterDurationData = computed(() => {
      // start
      let val = {
        "All Time": null,
      };

      let valPlus;

      if (responseDurationDefault.value) {
        if (responseDurationDefault.value.key == "filterDuration") {
          valPlus = responseDurationDefault.value.value.reduce((newArr, x) => {
            newArr[x.period] = null;
            return newArr;
          }, {});
          val = { ...val, ...valPlus };
        }
      }

      // return final
      return val;
    });

    // filter
    onMounted(() => {
      // initialize filterCategory
      let val = [
        { cat: "Processed", item: "v" },
        { cat: "Submitted", item: "p" },
        // { cat: "Reconciled", item: "r" },
        { cat: "Un-submitted", item: "q" },
      ];

      // set
      responseCategoryDefault.value = { key: "filterCategory", value: val };
    });

    // filter (Initialize)
    onMounted(() => {
      // initialize filterDuration
      const { fx } = searchMonths();

      // set
      responseDurationDefault.value = {
        key: "filterDuration",
        value: fx.value,
      };
    });

    // filter components
    const handleSearch = (val) => {
      if (val.id == "filterCategory") {
        // preset onMounted
      } else if (val.id == "filterDuration") {
        // preset onMounted
      }
    };

    // null reset
    const handleClear = (val) => {
      if (val.id == "filterCategory") {
        resetCategory.value = val.value;
      } else if (val.id == "filterDuration") {
        resetDuration.value = val.value;
      }
    };

    // get option
    const handlePick = (val) => {
      selectedItem.value = val;
      // watchEffect will take over from here
    };

    // search watcher
    watchEffect(() => {
      // token
      let searchToken = false;

      // start
      if (selectedItem.value) {
        // sort
         if (selectedItem.value.id == "filterPass") {
          // set token
          searchToken = true;

         } if (selectedItem.value.id == "filterCategory") {
          // set token
          searchToken = true;

          //set
          if (
            Object.keys(filterCategoryData.value)[0] == selectedItem.value.value
          ) {
            selectedCategory.value = "";
            searchBody.value = searchBody.value.filter((x) => !x.includes("Status"));
          } else {
            // update search body
            searchBody.value = searchBody.value.filter((x) => !x.includes("Status"));
            searchBody.value = searchBody.value.filter(
              (x) => !x.includes("Provider") && !x.includes("Period")
            );
            searchBody.value.push(`Status (${selectedItem.value.value})`);
            // get enrollee number from name or enrollee_number (self)
            // responseSearch will have all the complete data
            responseCategoryDefault.value.value.forEach((x) => {
              if (x.cat == selectedItem.value.value) {
                // found
                selectedCategory.value = x.item;
              }
            });
            if (selectedCategory.value) {
              // reset search fields (for better search results)
              resetDuration.value = Object.keys(filterDurationData.value)[0];
              // clear corresponding search
              selectedDuration.value = "";
            }
          }

        } else if (selectedItem.value.id == "filterDuration") {
          // set token
          searchToken = true;

          //set
          if (
            Object.keys(filterDurationData.value)[0] == selectedItem.value.value
          ) {
            selectedDuration.value = "";
            searchBody.value = searchBody.value.filter(
              (x) => !x.includes("Period")
            );
          } else {
            // update search body
            searchBody.value = searchBody.value.filter(
              (x) => !x.includes("Period")
            );
            searchBody.value = searchBody.value.filter(
              (x) => !x.includes("Provider") && !x.includes("Status")
            );
            searchBody.value.push(`Period (${selectedItem.value.value})`);
            // get duration day
            // responseDurationDefault will have all the complete data
            responseDurationDefault.value.value.forEach((x) => {
              if (x.period == selectedItem.value.value) {
                // found
                // Split the date
                const [year, month] = x.date.split('-');
                // re-format // remove leading zero
                selectedDuration.value = `${Number(month)}_${year}`;
              }
            });
            if (selectedDuration.value) {
              // reset search fields (for better search results)
              resetCategory.value = Object.keys(filterCategoryData.value)[0];
              // clear corresponding search
              selectedCategory.value = "";
            }
          }
        }

        if (searchToken) {
          // start laoding
          let searchTitle = null;
          let currUrl = null;
          let currHook = null;

          // label
          if (
            selectedCategory.value ||
            selectedDuration.value
          ) {
            let uniqueBody = [...new Set(searchBody.value)];
            searchTitle = `<span class="black blue-text chip">Search <i class="tiny material-icons">check_circle</i></span>`;
            uniqueBody.forEach((x) => {
              searchTitle += `<span class="yellow lighten-2 black-text chip"><em>${x}</em></span> `;
            });
            searchTitle = searchTitle.slice(0, -2);
          } else {
            searchTitle = null;
          }

          /* 
          Move on...
          */

          // set current Url
          currUrl = "cluster/provider/search";
          // set current Hook
          currHook = `?c=${selectedCategory.value}&d=${selectedDuration.value}`;

          // emit new parameters
          context.emit("search", {
            searchTitle: searchTitle,
            currUrl: currUrl,
            currHook: currHook,
          });


          // kill token
          searchToken = false;
          // kill searchItem
          selectedItem.value = null;
        }
      }
    });

    return {
      handleSearch,
      handleClear,
      handlePick,
      selectedItem,
      resetCategory,
      resetDuration,
      filterCategoryData,
      filterDurationData,
      selectedCategory,
      selectedDuration,
    };
  },
};
</script>

<style></style>